import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=72e13b7a&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e13b7a",
  null
  
)

export default component.exports